import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent } from '@icms/core/content';
import { NPageHeader } from '../../../page-header.component';

@Component({
    selector: 'page-header-meganav-content-item',
    templateUrl: 'page-header-meganav-content-item.html',
    styleUrls: ['page-header-meganav-content-item.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageHeaderMeganavContentItemComponent>({
    id: 'meganav-content-item',
    name: 'Meganav content item',
    onDemandOnly: true,
    fields: NPageHeader.meganavItemFields
})
export class PageHeaderMeganavContentItemComponent extends UiComponent {
    @ICmsContent({
        type: 'component'
    })
    @Input()
    component?: NPageHeader.IMeganavItem;

    /** True when a column contains only image items (a banner column). */
    protected isImageColumn(column: NPageHeader.IMeganavItemSubmenuColumn): boolean {
        return !!column.items?.length && column.items.every((item) => item.type === 'image');
    }

    /** Row-bands a text column occupies: 3 (title / links / View All) per text item. */
    protected columnRowSpan(column: NPageHeader.IMeganavItemSubmenuColumn): number {
        return (column.items ?? []).reduce((total, item) => total + (item.type === 'text' ? 3 : 0), 0);
    }

    /**
     * Row tracks for the columns grid: the tallest text column's band count.
     * Each text column is a row-subgrid spanning its own bands, so same-row categories
     * share track heights and their titles / View All align adaptively.
     */
    protected get columnsGridRows(): number {
        return Math.max(1, ...(this.component?.columns ?? []).map((column) => this.columnRowSpan(column)));
    }
}
